import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FloatingInput } from "../../Components/Common";
import * as DayService from "../../Services/DayService";
import { HOME } from "../../routes";
import { MESSAGES } from "./constants";

const MarkComplete = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const location = useLocation();
  const task = location.state?.task;

  if (!task) {
    toast.error(MESSAGES.TASK_DETAILS_MISSING);
    navigate(HOME);
    return null;
  }

  const initialAttendanceValue = {
    task_title: task.task_title || "",
    date: new Date().toISOString().split("T")[0],
    end_time: new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    }),
    task_description: task.task_description || "",
    is_last_task: false,
  };

  // To be done later
  const handleSubmit = async (values) => {
    if (submitting) return;
    setSubmitting(true);

    const formData = new FormData();
    formData.append("end_time", values.end_time);
    formData.append("task_description", values.task_description);
    formData.append("is_last_task", values.is_last_task);
    formData.append("status", "completed");
    try {
      const response = await DayService.MarkComplete(task.id, formData);
      if (response.status === 200) {
        toast.success(MESSAGES.TASK_COMPLETED);
        navigate(HOME);
      } else {
        toast.error(MESSAGES.FAILED_SUBMISSION);
      }
    } catch (error) {
      toast.error(MESSAGES.FAILED_SUBMISSION);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto rounded-lg flex justify-center items-center">
      <div className="bg-white rounded-lg p-2 w-full max-w-3xl shadow-md">
        <div className="flex items-center justify-start gap-16 md:gap-60 mb-4">
          <button
            type="button"
            onClick={() => navigate(HOME)}
            className="text-primary hover:text-secondary text-2xl"
            title="Back"
          >
            <HiOutlineArrowLeft />
          </button>
          <h2 className="text-2xl font-bold text-primary text-center">
            Mark Task Complete
          </h2>
        </div>

        <Formik initialValues={initialAttendanceValue} onSubmit={handleSubmit}>
          {() => (
            <Form className="text-secondary px-2">
              <div>
                <FloatingInput
                  label="Title"
                  name="task_title"
                  type="text"
                  disabled={true}
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block font-medium">Date</label>
                  <Field
                    name="date"
                    type="date"
                    disabled={true}
                    className="w-full border border-gray-300 rounded px-3 mt-1 text-gray-500 bg-gray-100 cursor-not-allowed"
                  />
                  <ErrorMessage
                    name="date"
                    component="div"
                    className="text-red-600 text-sm"
                  />
                </div>
                <div>
                  <label className="block font-medium">Time</label>
                  <Field
                    name="end_time"
                    type="time"
                    disabled
                    className="w-full border border-gray-300 rounded px-3 mt-1 text-gray-500 bg-gray-100 cursor-not-allowed"
                  />
                  <ErrorMessage
                    name="end_time"
                    component="div"
                    className="text-red-600 text-sm"
                  />
                </div>
              </div>
              <div className="mt-4">
                <FloatingInput
                  label="Task Description"
                  name="task_description"
                  type="text"
                />
              </div>
              <div className="mt-4 flex items-center gap-2">
                <Field name="is_last_task">
                  {({ field, form }) => (
                    <>
                      <input
                        type="checkbox"
                        {...field}
                        checked={field.value}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          if (checked) {
                            const confirm = window.confirm(
                              MESSAGES.ACTION_CONFIRMATION
                            );
                            if (confirm) {
                              form.setFieldValue("is_last_task", true);
                            } else {
                              form.setFieldValue("is_last_task", false);
                            }
                          } else {
                            form.setFieldValue("is_last_task", false);
                          }
                        }}
                        className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded"
                      />
                      <label
                        htmlFor="is_last_task"
                        className="text-gray-700 font-medium"
                      >
                        Last Task??
                      </label>
                    </>
                  )}
                </Field>
              </div>

              <div className="flex justify-between mt-8">
                {/* CSS to be done based after viewing other pages */}
                <button
                  type="button"
                  onClick={() => navigate(HOME)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  className={`px-4 py-2 text-white rounded transition ${
                    submitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-primary hover:bg-secondary"
                  } `}
                >
                  {submitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default MarkComplete;
